import _asyncToGenerator from "/opt/render/project/src/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.string.trim.js";
import "regenerator-runtime/runtime.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-19cc7ee2"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "content-shape container py-0 h-100 d-flex flex-column align-items-center justify-content-center"
};
var _hoisted_2 = {
  key: 0,
  class: "mb-2"
};

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "d-inline-block circle rounded-circle me-2 rounded-2"
  }, null, -1);
});

var _hoisted_4 = {
  class: "pt-2 mt-4"
};

var _hoisted_5 = /*#__PURE__*/_createTextVNode("Sign in");

var _hoisted_6 = /*#__PURE__*/_createTextVNode(" to join ");

var _hoisted_7 = /*#__PURE__*/_createTextVNode(" Join ");

var _hoisted_8 = /*#__PURE__*/_createTextVNode(" You are already part of this group, ");

var _hoisted_9 = /*#__PURE__*/_createTextVNode("click here");

var _hoisted_10 = /*#__PURE__*/_createTextVNode(" to view its page. ");

var _hoisted_11 = /*#__PURE__*/_createTextVNode("Try again");

import { ref, reactive } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useLoadingBar } from "naive-ui";
import { useUserStore } from "@/store/user";
import { LoaderState as LoaderStateEnum } from "@/types/generic";
import { getErrorMessage, handleError } from "@/utils/errors";
import Link from "@/components/utils/Link.vue";
import http from "@/http";
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var router = useRouter();
    var route = useRoute();
    var loadingBar = useLoadingBar();
    var userStore = useUserStore();
    var LoaderState = LoaderStateEnum;
    var loaders = reactive({
      validation: LoaderStateEnum.Idle,
      join: LoaderStateEnum.Idle
    });
    var errors = reactive({});
    var invalidMessage = "Sorry, this link is no longer valid.";
    var invalid = ref(false);
    var direct = ref(false);
    var joined = ref(false);
    var group = ref(null);
    var user = ref(null);

    var validate = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _yield$http$post, response;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                loadingBar.start();
                loaders.validation = LoaderStateEnum.Loading;
                _context2.prev = 2;
                _context2.next = 5;
                return http.post("/groups/checkinvitationtoken", {
                  token: route.params.token
                });

              case 5:
                _yield$http$post = _context2.sent;
                response = _yield$http$post.data;
                group.value = response.group;
                user.value = response.createdByUser;
                direct.value = response.directinvit;
                joined.value = response.alreadyingroup;
                loaders.validation = LoaderStateEnum.Loaded;
                loadingBar.finish();
                _context2.next = 22;
                break;

              case 15:
                _context2.prev = 15;
                _context2.t0 = _context2["catch"](2);
                _context2.next = 19;
                return handleError(_context2.t0, {
                  http: function () {
                    var _http = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
                      var _e$response, _e$response2, _e$response2$data;

                      return regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              invalid.value = ((_e$response = e.response) === null || _e$response === void 0 ? void 0 : _e$response.status) === 404;
                              return _context.abrupt("return", invalid.value ? invalidMessage : getErrorMessage((_e$response2 = e.response) === null || _e$response2 === void 0 ? void 0 : (_e$response2$data = _e$response2.data) === null || _e$response2$data === void 0 ? void 0 : _e$response2$data.errors));

                            case 2:
                            case "end":
                              return _context.stop();
                          }
                        }
                      }, _callee);
                    }));

                    function http(_x) {
                      return _http.apply(this, arguments);
                    }

                    return http;
                  }()
                });

              case 19:
                errors.validation = _context2.sent;
                loaders.validation = LoaderStateEnum.Failed;
                loadingBar.error();

              case 22:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[2, 15]]);
      }));

      return function validate() {
        return _ref.apply(this, arguments);
      };
    }();

    var join = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _group$value;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                loaders.join = LoaderStateEnum.Loading;
                _context3.prev = 1;
                _context3.next = 4;
                return http.post("/groups/requestAcceptation", {
                  token: route.params.token
                });

              case 4:
                loaders.join = LoaderStateEnum.Idle;
                _context3.next = 7;
                return router.push({
                  name: "Group",
                  params: {
                    id: (_group$value = group.value) === null || _group$value === void 0 ? void 0 : _group$value.groupId
                  }
                });

              case 7:
                _context3.next = 15;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3["catch"](1);
                _context3.next = 13;
                return handleError(_context3.t0);

              case 13:
                errors.join = _context3.sent;
                loaders.join = LoaderStateEnum.Failed;

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[1, 9]]);
      }));

      return function join() {
        return _ref2.apply(this, arguments);
      };
    }();

    validate();
    return function (_ctx, _cache) {
      var _component_n_text = _resolveComponent("n-text");

      var _component_n_h2 = _resolveComponent("n-h2");

      var _component_n_tag = _resolveComponent("n-tag");

      var _component_n_space = _resolveComponent("n-space");

      var _component_n_ellipsis = _resolveComponent("n-ellipsis");

      var _component_n_p = _resolveComponent("n-p");

      var _component_n_button = _resolveComponent("n-button");

      var _component_router_link = _resolveComponent("router-link");

      var _component_n_alert = _resolveComponent("n-alert");

      var _component_n_card = _resolveComponent("n-card");

      var _component_n_result = _resolveComponent("n-result");

      var _component_n_skeleton = _resolveComponent("n-skeleton");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_unref(loaders).validation !== _unref(LoaderState).Loading ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_unref(loaders).validation !== _unref(LoaderState).Failed ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [group.value ? (_openBlock(), _createBlock(_component_n_card, {
        key: 0,
        class: "invite-card p-3",
        bordered: false,
        embedded: ""
      }, {
        default: _withCtx(function () {
          return [user.value ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_n_text, {
            class: "d-flex flex-row align-items-center",
            type: "info"
          }, {
            default: _withCtx(function () {
              return [_hoisted_3, _createTextVNode(" " + _toDisplayString(user.value.userName) + " invited you to join ", 1)];
            }),
            _: 1
          })])) : _createCommentVNode("", true), _createVNode(_component_n_h2, {
            class: "m-0 mb-2"
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("strong", null, _toDisplayString(group.value.name), 1)];
            }),
            _: 1
          }), _createVNode(_component_n_space, null, {
            default: _withCtx(function () {
              return [_createVNode(_component_n_tag, {
                class: "rounded-2"
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode(_toDisplayString(group.value.membersNb) + " members", 1)];
                }),
                _: 1
              }), _createVNode(_component_n_tag, {
                class: "rounded-2"
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode(_toDisplayString(group.value.messagesNb) + " messages", 1)];
                }),
                _: 1
              })];
            }),
            _: 1
          }), group.value.description && group.value.description.trim().length > 0 ? (_openBlock(), _createBlock(_component_n_p, {
            key: 1,
            class: "text-break"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_n_text, {
                depth: "3"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_n_ellipsis, {
                    "line-clamp": 4,
                    tooltip: false
                  }, {
                    default: _withCtx(function () {
                      return [_createTextVNode(_toDisplayString(group.value.description), 1)];
                    }),
                    _: 1
                  })];
                }),
                _: 1
              })];
            }),
            _: 1
          })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_4, [!_unref(userStore).authenticated ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: {
              name: 'Signin',
              query: {
                to: _unref(route).fullPath
              }
            },
            class: "text-decoration-none"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_n_button, {
                type: "info",
                size: "large",
                block: ""
              }, {
                default: _withCtx(function () {
                  return [_createElementVNode("div", null, [_createVNode(_component_n_text, {
                    type: "none",
                    strong: ""
                  }, {
                    default: _withCtx(function () {
                      return [_hoisted_5];
                    }),
                    _: 1
                  }), _hoisted_6])];
                }),
                _: 1
              })];
            }),
            _: 1
          }, 8, ["to"])) : (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_createVNode(_component_n_button, {
            type: "success",
            size: "large",
            block: "",
            loading: _unref(loaders).join === _unref(LoaderState).Loading,
            disabled: joined.value,
            onClick: join
          }, {
            default: _withCtx(function () {
              return [_hoisted_7];
            }),
            _: 1
          }, 8, ["loading", "disabled"]), _unref(loaders).join === _unref(LoaderState).Failed ? (_openBlock(), _createBlock(_component_n_alert, {
            key: 0,
            type: "error",
            class: "white-space-pre-line mt-3",
            "show-icon": false
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_unref(errors).join), 1)];
            }),
            _: 1
          })) : joined.value ? (_openBlock(), _createBlock(_component_n_alert, {
            key: 1,
            type: "warning",
            class: "white-space-pre-line mt-3",
            "show-icon": false
          }, {
            default: _withCtx(function () {
              return [_hoisted_8, _createVNode(Link, {
                to: {
                  name: 'Group',
                  params: {
                    id: group.value.groupId
                  }
                }
              }, {
                default: _withCtx(function () {
                  return [_hoisted_9];
                }),
                _: 1
              }, 8, ["to"]), _hoisted_10];
            }),
            _: 1
          })) : _createCommentVNode("", true)], 64))])];
        }),
        _: 1
      })) : _createCommentVNode("", true)], 64)) : (_openBlock(), _createBlock(_component_n_result, {
        key: 1,
        status: "error",
        title: invalid.value ? 'Invalid link' : 'Error',
        description: _unref(errors).validation
      }, _createSlots({
        _: 2
      }, [!invalid.value ? {
        name: "footer",
        fn: _withCtx(function () {
          return [_createVNode(_component_n_button, {
            onClick: _cache[0] || (_cache[0] = function ($event) {
              return validate();
            })
          }, {
            default: _withCtx(function () {
              return [_hoisted_11];
            }),
            _: 1
          })];
        })
      } : undefined]), 1032, ["title", "description"]))], 64)) : (_openBlock(), _createBlock(_component_n_skeleton, {
        key: 1,
        class: "invite-skeleton invite-card rounded-3"
      }))]);
    };
  }
});